import { Tag, Tooltip } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { ProductErrorCount as ErrorCount } from 'views/declarations/declaration-tabs/declaration-form/tabs/products/getErrorCountsByRow';

const pluralizeErrors = (count: number) => `${count} ${count === 1 ? 'error' : 'errors'}`;

/** Where the errors come from, e.g. "2 errors from the customs rejection, 1 error from the form validation". */
const getBreakdown = ({ customs, validation }: ErrorCount) => {
    const sources = [];
    if (customs) sources.push(`${pluralizeErrors(customs)} from the customs rejection`);
    if (validation) sources.push(`${pluralizeErrors(validation)} from the form validation`);
    return sources.join(', ');
};

interface Props {
    count: ErrorCount;
}

const ProductErrorCount = ({ count }: Props) => {
    const total = count.customs + count.validation;

    return (
        <Tooltip title={getBreakdown(count)}>
            <Tag
                color="error"
                icon={<ExclamationCircleOutlined style={{ color: 'var(--error-normal)' }} />}
                style={{ borderRadius: 999, marginRight: 0, marginTop: 6 }}
            >
                {total}
            </Tag>
        </Tooltip>
    );
};

export default ProductErrorCount;
